import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
export const selectComponentOverrides = {
    MuiSelect: {
        defaultProps: {
            IconComponent: KeyboardArrowDownIcon
        }
    }
};
